module.exports = __webpack_public_path__ + "img/distribution-Y.ac8a2f7c.svg";